import { render, staticRenderFns } from "./CrewChangeFilter.vue?vue&type=template&id=523ffed8&scoped=true&"
import script from "./CrewChangeFilter.vue?vue&type=script&lang=js&"
export * from "./CrewChangeFilter.vue?vue&type=script&lang=js&"
import style0 from "./CrewChangeFilter.vue?vue&type=style&index=0&id=523ffed8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ffed8",
  null
  
)

export default component.exports